import { Model } from '@vuex-orm/core';

export default class CalculatorSettings extends Model {
  static entity = 'calculatorsettings';

  static state() {
    return {
      hasCalculator: false,
      hasCommunalPrice: false,
      hasMortgage: false,
      hasTaxDeduction: false,
      hasOptions: false,
      equity: 0,
      mortgageInterestRate: 1.5,
      mortgageYears: 20,
    }
  }

  static fields() {
    return {
      id: this.uid(),
      hasCalculator: this.boolean(false),
      optionPricingSetting: this.boolean(false),

      interestRateIndividualSelect: this.boolean(false),
      interestRateIndividual: this.number(0),
      individualLoanDescription: this.attr(null),

      depositSize: this.number(0),
      depositDescription: this.attr(null),
      communalLoanDescription: this.attr(null),
      communalLoanYears: this.attr(null),

      interestRateCommunal: this.number(0),
      interestFee: this.number(0),
      interestRateCommunalDescription: this.attr(null),

      interestRateCommunalExtras: this.attr(null),

      interestRateCommunalSecondary: this.number(0),
      interestRateCommunalSecondarySize: this.number(0),

      installmentPeriods: this.attr(null),

      fixedMonthlyCosts: this.number(0),
      flexibleMonthlyCosts: this.number(0),
      monthlyCostsDescription: this.attr(null),

      taxDeductionCheck: this.boolean(false),
      taxDeductionValue: this.number(0),
      taxDeductionDescription: this.attr(null),

    }
  }
}